import Component from "../core/Component"
import Scroll, { scrollToElement } from "../services/Scroll"
import throttle from "lodash/throttle"

export const STATES = {}

export const EMITS = {
    SECTION_CHANGE: "section-change"
}

export default class SectionObserver extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            sections: []
        }

        this.handleScroll = throttle(this.handleScroll, 300)

        this.offset = -200
        this.index = null
    }

    prepare() {
        this.resize()
        this.update()

        Scroll.on("scroll", this.handleScroll)
        window.addEventListener('resize', this.handleResize)
    }

    destroy() {
        Scroll.off("scroll", this.handleScroll)
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = () => {
        this.update()
    }

    resize() {
        this.offset = -window.innerHeight / 2
    }

    update() {
        const index = this.ref.sections.findIndex(section => section === this.getSectionInView())

        if (!~index || this.index === index) {
            return
        }

        this.index = index

        this.emit(EMITS.SECTION_CHANGE, { index })
    }


    getSectionInView() {
        let smallestNegativeNumberFound = Number.NEGATIVE_INFINITY
        let sectionInView = null

        this.ref.sections.forEach(section => {
            const top = section.getBoundingClientRect().top + this.offset

            if (top < 0 && top > smallestNegativeNumberFound) {
                smallestNegativeNumberFound = top
                sectionInView = section
            }


        })

        return sectionInView
    }
}
